// extracted by mini-css-extract-plugin
export default {"proPlus":"proPlus___jcB0dyj","order":"order___jcB0dyj","invalid":"invalid___jcB0dyj","answer":"answer___jcB0dyj","answerIcon":"answerIcon___jcB0dyj","valid":"valid___jcB0dyj"};